export enum IconsEnum {
  WORD = 'pi-file-word',
  EXCEL = 'pi-file-excel',
  PDF = 'pi-file-pdf',
  IMAGE = 'pi-image',
  FILE = 'pi-file',
}